export default {
      id: "file-document-check-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#file-document-check",
      toString: function () {
        return this.url;
      }
    }